import { differenceInYears } from 'date-fns'

import { formatBirthday } from '../../../ana-toolbox'

const getAgeFromBirthday = (birthday: string) => {
  if (!birthday) return 0

  try {
    const birthdayDate = new Date(formatBirthday(birthday))

    return differenceInYears(new Date(), birthdayDate)
  } catch {
    return 0
  }
}

export default getAgeFromBirthday
